const MenuQuery = {
  addUserMeal: 'id name pmult venue { id }' +
    '  published tagsByItemId' + // Used for legacy menu.js
    '  optionSets { id modifierId name max free required options { id name ingredients } }' +
    '  sections {' +
    '    id name ' +
    '    items { ' +
    '      id menuId name description price ingredients modifiers imageUrl averageRating dietLevel' +
    '      userRatings { userId rating }' +
    '    }' +
    '  }',
}

export default MenuQuery
